<div class="reset-wrap">
  <po-container class="reset-card">
    <div class="reset-card-brand">
      <img [src]="(logoUrl$ | async) ?? 'assets/brand/logo-ascensus-positiva.png'" alt="Ascensus">
    </div>
    <h2>Redefinir senha</h2>
    <p class="hint">Informe sua nova senha (minimo 8 caracteres).</p>

    <po-password
      name="newPassword"
      p-label="Nova senha"
      [(ngModel)]="newPassword"
      p-required
      [p-minlength]="8">
    </po-password>

    <po-password
      name="confirmPassword"
      p-label="Confirmar nova senha"
      [(ngModel)]="confirmPassword"
      p-required>
    </po-password>

    <div class="actions">
      <po-button
        p-label="Redefinir"
        p-kind="primary"
        [p-loading]="loading"
        (p-click)="submit()">
      </po-button>
    </div>
  </po-container>
</div>
